module.exports = __webpack_public_path__ + "static/img/数字化图书馆 (1).586bfd2e.png";